import { useSelector } from "react-redux";
function useGetDeviceStatus() {
    const {
        UsedAppTimeDataModel
    } = useSelector(({ setRules }) => setRules);

    function getDeviceStatus() {
        if (UsedAppTimeDataModel) {
            const { deviceStatus } = UsedAppTimeDataModel;
            const { status } = deviceStatus||{};
            const { deviceStatus : devStatus } = status||{};

            if(devStatus === 1) {
                return {
                    className: 'success',
                    text: 'online'
                }
            } else if(devStatus === 0) {
                return {
                    className: 'danger',
                    text: 'offline'
                }
            } else {
                return {
                    className: 'warning',
                    text: 'idle'
                }
            }
        } 

        return {
            className: '',
            text: 'Status unknown'
        };
    }

    return {
        getDeviceStatus
    }

}

export default useGetDeviceStatus;